import { api } from "./api";

export const userApiSlice = api.injectEndpoints({
  endpoints: (build) => ({
    // Public registration
    registerUser: build.mutation({
      query: (data) => ({
        url: `user/register`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["users", "pendingRegistrations"],
    }),

    // Approve registration
    approveRegistration: build.mutation({
      query: (data) => ({
        url: `user/approveRegistration`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["users", "pendingRegistrations", "eventRegistrations"],
    }),

    // Reject registration
    rejectRegistration: build.mutation({
      query: (data) => ({
        url: `user/rejectRegistration`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["users", "pendingRegistrations", "eventRegistrations"],
    }),

    // Check-in user with QR code
    checkInUser: build.mutation({
      query: (data) => ({
        url: `user/checkIn`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["users", "eventRegistrations"],
    }),

    sendBroadcastEmail: build.mutation({
      query: (formData) => ({
        url: `user/sendBroadcastEmail`,
        method: "POST",
        body: formData,
        // Important: Don't set content-type for FormData, browser will set it with boundary
      }),
      invalidatesTags: ["users"],
    }),

    // Get pending registrations for an event
    getPendingRegistrations: build.query({
      query: (eventId) => ({
        url: `user/getPendingRegistrations`,
        method: "POST",
        body: { eventId },
      }),
      providesTags: ["pendingRegistrations"],
    }),

    // Get all registrations for an event
    getEventRegistrations: build.query({
      query: (eventId) => ({
        url: `user/getEventRegistrations`,
        method: "POST",
        body: { eventId },
      }),
      providesTags: ["eventRegistrations"],
    }),

    // Get all users (admin)
    getUsers: build.query({
      query: () => `user/getUsers`,
      providesTags: ["users"],
    }),
  }),
});

export const {
  useRegisterUserMutation,
  useApproveRegistrationMutation,
  useRejectRegistrationMutation,
  useCheckInUserMutation,
  useGetPendingRegistrationsQuery,
  useGetEventRegistrationsQuery,
  useGetUsersQuery,
  useSendBroadcastEmailMutation,
} = userApiSlice;
